const UPDATE_ADDENDUMS = 'UPDATE_ADDENDUMS';
const RESET_ADDENDUMS = 'RESET_ADDENDUMS';

const initialState = {
  addendums: [],
  // The lease the addenda belong to, so a save never sends another lease's selection.
  leaseId: undefined,
  // True only after the packet loaded this lease's addenda from successful reads.
  isReady: false,
};

function leasePacketReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ADDENDUMS: {
      return {
        ...state,
        addendums: action.payload.addendums,
        leaseId: action.payload.leaseId,
        isReady: true,
      };
    }
    case RESET_ADDENDUMS:
      return initialState;
    default:
      return state;
  }
}

export const updateAddendums = (addendums, leaseId) => ({
  type: UPDATE_ADDENDUMS,
  payload: { addendums, leaseId },
});

export const resetAddendums = () => ({ type: RESET_ADDENDUMS });

// Returns undefined unless the packet loaded the stored selection for this lease. A save then
// omits optionalAddendums and the backend keeps the lease's saved addenda. A new lease's form has
// id null and its save mapper drops the id, so null and a missing id are the same unsaved lease.
export const getSelectedOptionalAddendumIds = (state, leaseId) =>
  state.leasePacket.isReady &&
  (state.leasePacket.leaseId ?? null) === (leaseId ?? null)
    ? state.leasePacket.addendums
        .filter((a) => a.isRequired !== true && a.isSelected === true)
        .map((a) => a.id)
    : undefined;

export default leasePacketReducer;
